import React from 'react'
import { StatusDotWrapper, StatusDot } from './styles'

export const statusDotFormatter = (cell, row, rowIndex, formatExtraData) => {
  const { theme, field } = formatExtraData
  let color
  let text

  switch (row[field]) {
    case true:
      color = theme.mocaGreen
      break;
    case false:
      color = theme.mocaRed
      break;
    default:
      color = theme.mocaGreen
      break;
  }

  switch (row[field]) {
    case true:
      text = 'Active'
      break;
    case false:
      text = 'Inactive'
      break;
    default:
      text = row[field]
      break;
  }

  return (
    <div>
      <StatusDotWrapper>
        <StatusDot background={color} />
        {text}
      </StatusDotWrapper>
    </div>
  )
}
